module.exports = __webpack_public_path__ + "static/media/2XL.1936db12.jpg";